import type { MetaIcon } from "../constants/icon.constant";
import GradientIconBuilder from "../helpers/GradientIconBuilder";
import SolidIconBuilder from "../helpers/SolidIconBuilder";

interface PrimaryIconProps {
  icon: MetaIcon;
  isActive?: boolean;
}

export default function PrimaryIcon(props: Readonly<PrimaryIconProps>) {
  return (props.isActive ? GradientIconBuilder : SolidIconBuilder)({
    icon: props.icon,
    colors: ["#F4C553", "#DAA934", "#BF8C15"],
    color: "white",
  });
}
